<template>
  <!--工位柏拉图-->
  <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{title}}</div>
      <div style="height:100%;width:100%;" id="stationEchart"></div>
    </div>
  </dv-border-box-13>
</template>

<script>
import differenceInMinutes from "date-fns/differenceInMinutes";
export default {
  name: "andon-center",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    plato: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle:{
      type: String,
      default: function () {
        return "工位柏拉图";
      },
    },
    statusMap: { 0: "待确认", 1: "待处理", 2: "处理中", 3: "待评价" },
  },
  data() {
    return {
      title:this.headTitle,
      platosCharts: undefined,
      platos: this.plato,
    };
  },
  watch: {
    plato: {
      handler: function (val, oldVal) {
        this.platos = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    lineEchart() {
      var _this = this;
      var data = _this.platos;

      let total = 0;
      data.forEach((res) => {
        total += res["issueCount"];
      });

      var fold = 0;
      for (var i = 0; i < data.length; i++) {
        var quantity = data[i]["issueCount"];
        fold += quantity;
        var probability = 0;
        var proportion = 0;

        if (fold != 0) {
          probability = parseInt((fold / total) * 100 + "", 0);
          proportion = parseInt((quantity / total) * 100 + "", 0);
        }

        data[i]["proportion"] = proportion;
        data[i]["probability"] = probability;
      }

      let daset = [];
      let barData = [];
      let lineData = [];
      data.forEach((res) => {
        daset.push(res["title"]);
        barData.push(res["issueCount"]);
        lineData.push(res["probability"]);
      });

      var echart = this.$echarts.init(document.getElementById("stationEchart"));
      var option = {
        color: ["#CA0000"],
        legend: {
          top: 0,
          bottom: 20,
          //     right: "15",
          data: ["报警数", "累计"],
          textStyle: {
            color: "#ffffff",
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          x: 30,
          y2: 40,
          y: 40,
        },
        xAxis: [
          {
            type: "category",
            data: daset,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ["none"],
              symbolOffset: 12,
              lineStyle: {
                color: "#fff",
              },
            },
            z: 10,
            axisLabel: {
              interval: 0,
              rotate: 30,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "报警数",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "累计",
            min: 0,
            scale: true,
            axisLabel: {
              formatter: "{value} %",
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "报警数",
            type: "bar",
            barWidth: "60%",
            label: {
              show: true,
              color: "#fff",
              position: "top",
            },
            data: barData,
          },
          {
            color: ["#FFFFFF"],
            name: "累计",
            type: "line",
            yAxisIndex: 1,
            smooth: true,
            data: lineData,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#FFFFFF",
                    fontSize: 12,
                  },
                  formatter: "{c}% ",
                },
              },
            },
          },
        ],
      };

      echart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        echart.resize();
      });

      if (_this.platosCharts) {
        clearInterval(_this.platosCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      _this.platosCharts = setInterval(function () {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= daset.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.cookie) {
      clearInterval(this.cookie);
    }
    if (this.refreshTime) {
      clearInterval(this.refreshTime);
    }
  },
};
</script>


<style scoped>
#child2 {
  scroll-behavior: smooth;
}
#child1 {
  scroll-behavior: smooth;
}
.item {
  padding: 0.33rem 0.4rem;
}
/* 头部标题 */
.head {
  list-style: none;
  margin: 0;
  padding: 0;
}
.head li {
  float: left;
  width: 200px;
  line-height: 40px;
  text-align: center;
}
.parent {
  overflow: hidden;
}
/*设置的子盒子高度大于父盒子，产生溢出效果*/
.child {
  height: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.child li {
  text-align: center;
}
.li_item {
  width: 49.3%;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/station-plato.vue